import * as React from "react";

import type { SnapshotCollectionsSummary as SnapshotCollectionsSummaryValue } from "@/modules/snapshots/snapshotCollections/dashboardUtils";

interface Props {
  summary: SnapshotCollectionsSummaryValue;
}

const summaryMetrics = [
  {
    key: "collections",
    label: "Collections",
    help: "Active collections",
  },
  {
    key: "snapshots",
    label: "Snapshots",
    help: "Across all collections",
  },
  {
    key: "processing",
    label: "Processing",
    help: "Snapshots currently running",
  },
] satisfies Array<{
  key: keyof SnapshotCollectionsSummaryValue;
  label: string;
  help: string;
}>;

export const SnapshotCollectionsSummary: React.FC<Props> = ({ summary }) => (
  <section
    aria-label="Snapshot collections summary"
    className="grid overflow-hidden rounded-lg border border-[#ddd5cb] bg-[#fffdfb]/90 shadow-none md:grid-cols-3"
  >
    {summaryMetrics.map(metric => (
      <div
        key={metric.key}
        className="min-w-0 border-b border-[#e7e0d9] px-6 py-5 last:border-b-0 md:border-b-0 md:border-r md:last:border-r-0"
      >
        <p className="truncate text-sm font-semibold text-gray-700">{metric.label}</p>
        <p className="mt-1 text-3xl font-bold leading-none text-[#111b35]">{summary[metric.key]}</p>
        <p className="mt-1 truncate text-xs font-medium text-gray-500">{metric.help}</p>
      </div>
    ))}
  </section>
);
